 

import React from "react";

import { Link } from "react-router-dom";
import usePermissions from "../../../components/permissions/permission";

const EmpNav = () => {
  const { hasPermission } = usePermissions();
  const empData = [
    {
      id: 1,
      header: "Employee Quick Onboard",

      headerClasses: "text-black",
      linkTo: "/emp-nav",
      linkTo: "/emp-onboarding",
      permissionId: 1000,
    },
    {
      id: 2,
      header: "View Export Details",

      headerClasses: "text-black",
      linkTo: "/view-export-table",
      permissionId: 1001,
    },
    {
      id: 5,
      header: "History Log Edits",

      headerClasses: "text-black",
      linkTo: "/history-log",
      permissionId: 1002,
    },
  ];

  return (
    <div className="bg-background overflow-y-auto h-screen">
      <p className="text-[40px] font-header ml-6 mt-6 font-bold text-[#797C80] ">
        Employee
      </p>

      {/* Cards with "Click Here" buttons */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-12 mt-[10%] mx-6 ">
        {empData.map((card) =>
          hasPermission(card.permissionId) ? (
            <Link key={card.id} to={card.linkTo}>
              <div
                key={card.id}
                className="bg-white rounded-[32px] p-4 shadow-md flex flex-col justify-between"
              >
                <div>
                  {/* Conditional rendering based on header words */}
                  {card.header.split(" ").map((word, index) => (
                    <h2 key={index} className="text-[25px] font-bold mb-1 mt-1 ml-4 font-sans">
                      {word}
                    </h2>
                  ))}
                </div>
                <div className="flex justify-between items-center">
                  <button className="bg-primary w-[30%] mt-2 text-white font-bold py-2 px-4 rounded-[22px]">
                    Click Here
                  </button>

                  <div className="bg-primary w-[13px] h-[37px] rounded-xl"></div>
                </div>
              </div>
            </Link>
          ) : null
        )}
      </div>
    </div>
  );
};

export default EmpNav;
